/**
 * Workspace Service REST API
 *
 * Contact: ContactRequests@enverus.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams, HttpResponse, HttpEvent, HttpParameterCodec, HttpContext } from '@angular/common/http';
import { CustomHttpParameterCodec } from '../encoder';
import { Observable } from 'rxjs';

// @ts-ignore
import { Widget } from '../model/widget';
// @ts-ignore
import { WidgetMoveRequest } from '../model/widgetMoveRequest';
// @ts-ignore
import { WidgetOrdersResponse } from '../model/widgetOrdersResponse';
// @ts-ignore
import { WidgetUpdate } from '../model/widgetUpdate';

// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS } from '../variables';
import { WorkspacesAPIConfiguration } from '../configuration';
import { BaseService } from '../api.base.service';
import {
    WidgetControllerServiceInterface,
    CreateWidgetRequestParams,
    DeleteWidgetRequestParams,
    GetWidgetsByWindowRequestParams,
    MoveWidgetRequestParams,
    UpdateWidgetRequestParams
} from './widgetController.serviceInterface';

@Injectable({
    providedIn: 'root'
})
export class WidgetControllerService extends BaseService implements WidgetControllerServiceInterface {
    constructor(
        protected httpClient: HttpClient,
        @Optional() @Inject(BASE_PATH) basePath: string | string[],
        @Optional() configuration?: WorkspacesAPIConfiguration
    ) {
        super(basePath, configuration);
    }

    /**
     * Create widget
     * @param requestParameters
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public createWidget(
        requestParameters: CreateWidgetRequestParams,
        observe?: 'body',
        reportProgress?: boolean,
        options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext; transferCache?: boolean }
    ): Observable<Widget>;
    public createWidget(
        requestParameters: CreateWidgetRequestParams,
        observe?: 'response',
        reportProgress?: boolean,
        options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext; transferCache?: boolean }
    ): Observable<HttpResponse<Widget>>;
    public createWidget(
        requestParameters: CreateWidgetRequestParams,
        observe?: 'events',
        reportProgress?: boolean,
        options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext; transferCache?: boolean }
    ): Observable<HttpEvent<Widget>>;
    public createWidget(
        requestParameters: CreateWidgetRequestParams,
        observe: any = 'body',
        reportProgress: boolean = false,
        options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext; transferCache?: boolean }
    ): Observable<any> {
        const widget = requestParameters?.widget;
        if (widget === null || widget === undefined) {
            throw new Error('Required parameter widget was null or undefined when calling createWidget.');
        }

        let localVarHeaders = this.defaultHeaders;

        // authentication (Auth0) required
        localVarHeaders = this.configuration.addCredentialToHeaders('Auth0', 'Authorization', localVarHeaders, 'Bearer ');

        // authentication (Keycloak) required
        localVarHeaders = this.configuration.addCredentialToHeaders('Keycloak', 'Authorization', localVarHeaders, 'Bearer ');

        const localVarHttpHeaderAcceptSelected: string | undefined =
            options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept(['application/json']);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;

        // to determine the Content-Type header
        const consumes: string[] = ['application/json'];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
        }

        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/widgets`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<Widget>('post', `${basePath}${localVarPath}`, {
            context: localVarHttpContext,
            body: widget,
            responseType: <any>responseType_,
            ...(withCredentials ? { withCredentials } : {}),
            headers: localVarHeaders,
            observe: observe,
            transferCache: localVarTransferCache,
            reportProgress: reportProgress
        });
    }

    /**
     * Delete widget
     * @param requestParameters
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public deleteWidget(
        requestParameters: DeleteWidgetRequestParams,
        observe?: 'body',
        reportProgress?: boolean,
        options?: { httpHeaderAccept?: undefined; context?: HttpContext; transferCache?: boolean }
    ): Observable<any>;
    public deleteWidget(
        requestParameters: DeleteWidgetRequestParams,
        observe?: 'response',
        reportProgress?: boolean,
        options?: { httpHeaderAccept?: undefined; context?: HttpContext; transferCache?: boolean }
    ): Observable<HttpResponse<any>>;
    public deleteWidget(
        requestParameters: DeleteWidgetRequestParams,
        observe?: 'events',
        reportProgress?: boolean,
        options?: { httpHeaderAccept?: undefined; context?: HttpContext; transferCache?: boolean }
    ): Observable<HttpEvent<any>>;
    public deleteWidget(
        requestParameters: DeleteWidgetRequestParams,
        observe: any = 'body',
        reportProgress: boolean = false,
        options?: { httpHeaderAccept?: undefined; context?: HttpContext; transferCache?: boolean }
    ): Observable<any> {
        const id = requestParameters?.id;
        if (id === null || id === undefined) {
            throw new Error('Required parameter id was null or undefined when calling deleteWidget.');
        }

        let localVarHeaders = this.defaultHeaders;

        // authentication (Auth0) required
        localVarHeaders = this.configuration.addCredentialToHeaders('Auth0', 'Authorization', localVarHeaders, 'Bearer ');

        // authentication (Keycloak) required
        localVarHeaders = this.configuration.addCredentialToHeaders('Keycloak', 'Authorization', localVarHeaders, 'Bearer ');

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;

        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/widgets/${this.configuration.encodeParam({ name: 'id', value: id, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: undefined })}`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<any>('delete', `${basePath}${localVarPath}`, {
            context: localVarHttpContext,
            responseType: <any>responseType_,
            ...(withCredentials ? { withCredentials } : {}),
            headers: localVarHeaders,
            observe: observe,
            transferCache: localVarTransferCache,
            reportProgress: reportProgress
        });
    }

    /**
     * Get widgets of a window
     * @param requestParameters
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getWidgetsByWindow(
        requestParameters: GetWidgetsByWindowRequestParams,
        observe?: 'body',
        reportProgress?: boolean,
        options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext; transferCache?: boolean }
    ): Observable<Array<Widget>>;
    public getWidgetsByWindow(
        requestParameters: GetWidgetsByWindowRequestParams,
        observe?: 'response',
        reportProgress?: boolean,
        options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext; transferCache?: boolean }
    ): Observable<HttpResponse<Array<Widget>>>;
    public getWidgetsByWindow(
        requestParameters: GetWidgetsByWindowRequestParams,
        observe?: 'events',
        reportProgress?: boolean,
        options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext; transferCache?: boolean }
    ): Observable<HttpEvent<Array<Widget>>>;
    public getWidgetsByWindow(
        requestParameters: GetWidgetsByWindowRequestParams,
        observe: any = 'body',
        reportProgress: boolean = false,
        options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext; transferCache?: boolean }
    ): Observable<any> {
        const windowId = requestParameters?.windowId;
        if (windowId === null || windowId === undefined) {
            throw new Error('Required parameter windowId was null or undefined when calling getWidgetsByWindow.');
        }

        let localVarHeaders = this.defaultHeaders;

        // authentication (Auth0) required
        localVarHeaders = this.configuration.addCredentialToHeaders('Auth0', 'Authorization', localVarHeaders, 'Bearer ');

        // authentication (Keycloak) required
        localVarHeaders = this.configuration.addCredentialToHeaders('Keycloak', 'Authorization', localVarHeaders, 'Bearer ');

        const localVarHttpHeaderAcceptSelected: string | undefined =
            options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept(['application/json']);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;

        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/windows/${this.configuration.encodeParam({ name: 'windowId', value: windowId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: undefined })}/widgets`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<Array<Widget>>('get', `${basePath}${localVarPath}`, {
            context: localVarHttpContext,
            responseType: <any>responseType_,
            ...(withCredentials ? { withCredentials } : {}),
            headers: localVarHeaders,
            observe: observe,
            transferCache: localVarTransferCache,
            reportProgress: reportProgress
        });
    }

    /**
     * Move widget to new position with automatic reordering
     * @param requestParameters
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public moveWidget(
        requestParameters: MoveWidgetRequestParams,
        observe?: 'body',
        reportProgress?: boolean,
        options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext; transferCache?: boolean }
    ): Observable<WidgetOrdersResponse>;
    public moveWidget(
        requestParameters: MoveWidgetRequestParams,
        observe?: 'response',
        reportProgress?: boolean,
        options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext; transferCache?: boolean }
    ): Observable<HttpResponse<WidgetOrdersResponse>>;
    public moveWidget(
        requestParameters: MoveWidgetRequestParams,
        observe?: 'events',
        reportProgress?: boolean,
        options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext; transferCache?: boolean }
    ): Observable<HttpEvent<WidgetOrdersResponse>>;
    public moveWidget(
        requestParameters: MoveWidgetRequestParams,
        observe: any = 'body',
        reportProgress: boolean = false,
        options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext; transferCache?: boolean }
    ): Observable<any> {
        const windowId = requestParameters?.windowId;
        if (windowId === null || windowId === undefined) {
            throw new Error('Required parameter windowId was null or undefined when calling moveWidget.');
        }
        const widgetMoveRequest = requestParameters?.widgetMoveRequest;
        if (widgetMoveRequest === null || widgetMoveRequest === undefined) {
            throw new Error('Required parameter widgetMoveRequest was null or undefined when calling moveWidget.');
        }

        let localVarHeaders = this.defaultHeaders;

        // authentication (Auth0) required
        localVarHeaders = this.configuration.addCredentialToHeaders('Auth0', 'Authorization', localVarHeaders, 'Bearer ');

        // authentication (Keycloak) required
        localVarHeaders = this.configuration.addCredentialToHeaders('Keycloak', 'Authorization', localVarHeaders, 'Bearer ');

        const localVarHttpHeaderAcceptSelected: string | undefined =
            options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept(['application/json']);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;

        // to determine the Content-Type header
        const consumes: string[] = ['application/json'];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
        }

        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/windows/${this.configuration.encodeParam({ name: 'windowId', value: windowId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: undefined })}/widgets/move`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<WidgetOrdersResponse>('put', `${basePath}${localVarPath}`, {
            context: localVarHttpContext,
            body: widgetMoveRequest,
            responseType: <any>responseType_,
            ...(withCredentials ? { withCredentials } : {}),
            headers: localVarHeaders,
            observe: observe,
            transferCache: localVarTransferCache,
            reportProgress: reportProgress
        });
    }

    /**
     * Update widget
     * @param requestParameters
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public updateWidget(
        requestParameters: UpdateWidgetRequestParams,
        observe?: 'body',
        reportProgress?: boolean,
        options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext; transferCache?: boolean }
    ): Observable<Widget>;
    public updateWidget(
        requestParameters: UpdateWidgetRequestParams,
        observe?: 'response',
        reportProgress?: boolean,
        options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext; transferCache?: boolean }
    ): Observable<HttpResponse<Widget>>;
    public updateWidget(
        requestParameters: UpdateWidgetRequestParams,
        observe?: 'events',
        reportProgress?: boolean,
        options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext; transferCache?: boolean }
    ): Observable<HttpEvent<Widget>>;
    public updateWidget(
        requestParameters: UpdateWidgetRequestParams,
        observe: any = 'body',
        reportProgress: boolean = false,
        options?: { httpHeaderAccept?: 'application/json'; context?: HttpContext; transferCache?: boolean }
    ): Observable<any> {
        const id = requestParameters?.id;
        if (id === null || id === undefined) {
            throw new Error('Required parameter id was null or undefined when calling updateWidget.');
        }
        const widgetUpdate = requestParameters?.widgetUpdate;
        if (widgetUpdate === null || widgetUpdate === undefined) {
            throw new Error('Required parameter widgetUpdate was null or undefined when calling updateWidget.');
        }

        let localVarHeaders = this.defaultHeaders;

        // authentication (Auth0) required
        localVarHeaders = this.configuration.addCredentialToHeaders('Auth0', 'Authorization', localVarHeaders, 'Bearer ');

        // authentication (Keycloak) required
        localVarHeaders = this.configuration.addCredentialToHeaders('Keycloak', 'Authorization', localVarHeaders, 'Bearer ');

        const localVarHttpHeaderAcceptSelected: string | undefined =
            options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept(['application/json']);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;

        // to determine the Content-Type header
        const consumes: string[] = ['application/json'];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
        }

        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/widgets/${this.configuration.encodeParam({ name: 'id', value: id, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: undefined })}`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<Widget>('put', `${basePath}${localVarPath}`, {
            context: localVarHttpContext,
            body: widgetUpdate,
            responseType: <any>responseType_,
            ...(withCredentials ? { withCredentials } : {}),
            headers: localVarHeaders,
            observe: observe,
            transferCache: localVarTransferCache,
            reportProgress: reportProgress
        });
    }
}
